module.exports = __webpack_public_path__ + "static/Java-Iphone-Still-71ab9447c8f412714b320b51118d6d6a.jpg";